import { Box, Chip, Menu, MenuItem } from '@mui/material'
import React, { useContext, useState } from 'react'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'

const Status = ({ vehicle, setVehicle }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const { setToast } = useContext(GlobalContext)
  const handleStatusChange = (status) => {
    API.put('/fleet/' + vehicle._id, {
      status,
    }).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Vehicle Status Updated' })
        setVehicle((prev) => ({ ...prev, status }))
        setMenuAnchorEl(null)
      } else {
        setToast({
          message: 'Unable to change status, please try again later.',
        })
      }
    })
  }
  return (
    <Box>
      <Chip
        size="small"
        label={vehicle.status}
        sx={{ borderRadius: 1, fontWeight: 700 }}
        color={
          vehicle.status === 'Operational'
            ? 'anGreen'
            : vehicle.status === 'Out of Service'
            ? 'anRed'
            : 'anBlue'
        }
        onClick={(e) => setMenuAnchorEl(e.currentTarget)}
      />
      <Menu
        open={!!menuAnchorEl}
        anchorEl={menuAnchorEl}
        onClose={() => setMenuAnchorEl(false)}
        onChange={handleStatusChange}
      >
        <MenuItem onClick={() => handleStatusChange('Out of Service')}>
          Out of Service
        </MenuItem>
        <MenuItem
          onClick={() => handleStatusChange('Decontamination Required')}
        >
          Decontamination Required
        </MenuItem>
        <MenuItem onClick={() => handleStatusChange('Operational')}>
          Operational
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default Status
